import { Chip, Stack, StackProps } from "@mui/material"
import { KojinResult } from "interface/kojin"

type KojinFlagsProps = {
	kojin: KojinResult
} & StackProps
export const KojinFlags = ({
	kojin,
	...others
}: KojinFlagsProps) => (
	<Stack {...others} direction="row" alignItems="center" spacing={0.5} flexWrap="wrap" useFlexGap>
		{kojin.picksExpert ? <Chip variant="filled" color="careNet" label="ExpertPicker" size="small"/ > : <></> }
		{kojin.actor?.isComActor ? <Chip variant="filled" color="careNet" label="COM出演" size="small" /> : <></> }
		{kojin.actor?.isDvdActor ? <Chip variant="filled" color="careNet" label="DVD出演" size="small" /> : <></> }
		{kojin.actor?.isTvActor ? <Chip variant="filled" color="careNet" label="TV出演" size="small" /> : <></> }
		{kojin.score?.journal?.rank ? <Chip variant="filled" color="journal" label={`論文${kojin.score.journal.rank}位`} size="small" /> : <></>}
	</Stack>
)
